// service/Axios.js
import axios from "axios";

// Instância do axios configurada para o projeto TablesPage
export const api = axios.create({
  baseURL: "https://sheetdb.io/api/v1/",
  headers: {
    Authorization: "Bearer 9j7w2xhc22a8x7bx50x9jus6i8oua37iv4thsd9b"
  }
});
